function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#051c41;}.cls-2{fill:#b9caef;}.cls-3{fill:#fff;}.cls-4{fill:#e6e6e6;}.cls-5{fill:#060633;}.cls-6{fill:#fa7267;}.cls-7{fill:#ffb93e;}.cls-8{fill:#f5b691;}.cls-9{fill:#0b0755;}.cls-10{fill:#f2957a;}.cls-11{fill:#35488b;}.cls-12{fill:#02cc9a;}.cls-13{fill:#ffa412;}.cls-14{fill:#00a878;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Fail3");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M522.6,285.66c.13-7,58.51-55.9,4.44-121.69-20.06-24.42-55.45-24.36-65.14-40.92C446.43,96.61,448.2,64,427,40.34,400.26,10.48,340,.82,297.46,0c-36.18-.67-72.57,8.11-102.64,24.71C173.19,36.69,159.3,55.3,140.11,69.42,119,85,90.74,88.34,68.57,102.16,48.57,114.63,5,132.57.42,179.21c-4.31,43.73,25.67,88.22,54,104.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M547.83,292c0-15.59-122-28.23-272.57-28.23S2.7,276.45,2.7,292s122,28.23,272.56,28.23S547.83,307.63,547.83,292Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M294.39,88.07s4.46-4.54,7.15-14.32,4.93-17.26,9.09-15.35c3.5,1.6,1.05,9.93,1.05,9.93s4.6-8,7.32-1.42c2.14,5.21-2.91,13.78-2.91,13.78s2.54-3.52,3.65-1.93S320.39,91,306,93.13,292.46,90.82,294.39,88.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M313.73,65.71a14.4,14.4,0,0,0-2,2.64,22.86,22.86,0,0,0,.84-5.26,36,36,0,0,1-1.23,5.22A118.76,118.76,0,0,1,307.16,81s3.65-8.1,6.45-14.76A2.06,2.06,0,0,0,313.73,65.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M309.66,87.32a39.05,39.05,0,0,0,8.85-8.55l0-.3a7.72,7.72,0,0,0-2.47,2.24,30.79,30.79,0,0,0,2-4.18A41.86,41.86,0,0,1,309.66,87.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M260.11,88.07s-4.47-4.54-7.16-14.32S248,56.49,243.87,58.4c-3.5,1.6-1.06,9.93-1.06,9.93s-4.6-8-7.31-1.42c-2.14,5.21,2.9,13.78,2.9,13.78s-2.54-3.52-3.64-1.93S234.11,91,248.49,93.13,262,90.82,260.11,88.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M240.77,65.71a14.4,14.4,0,0,1,2,2.64,23.2,23.2,0,0,1-.85-5.26,37.37,37.37,0,0,0,1.24,5.22A121,121,0,0,0,247.33,81s-3.65-8.1-6.45-14.76A2.26,2.26,0,0,1,240.77,65.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M244.84,87.32A38.81,38.81,0,0,1,236,78.77l0-.3a7.72,7.72,0,0,1,2.47,2.24,30.79,30.79,0,0,1-2-4.18A41.86,41.86,0,0,0,244.84,87.32Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 282.71,
  y: 165.4,
  width: 5.76,
  height: 26.9
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 235.74,
  y: 186.42,
  width: 75.39,
  height: 22.55,
  rx: 11.27
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: 258.95,
  y: 111.83,
  width: 58.54,
  height: 58.54,
  rx: 29.27
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-5",
  x: 269,
  y: 208.97,
  width: 5.76,
  height: 81.41
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M300.46,292.1H243.18a1.73,1.73,0,1,1,0-3.46h57.28a1.73,1.73,0,0,1,0,3.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M251.8,295.69a4.21,4.21,0,1,0-4.21,4.21A4.21,4.21,0,0,0,251.8,295.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M299.22,295.69A4.21,4.21,0,1,0,295,299.9,4.21,4.21,0,0,0,299.22,295.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M276.09,295.69a4.21,4.21,0,1,0-4.21,4.21A4.2,4.2,0,0,0,276.09,295.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M248.39,84.72s-12,5.86-15.46,25.59-13.59,53.84,3.74,58.9S248.39,84.72,248.39,84.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M211.65,276s-1.1,14.62-1.21,14.82,1,2,1,2l4.52.81,4.13-1.89s2.24-14.26,2.67-16.36S211.65,276,211.65,276Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M220.13,291.77s-5.21,1.82-9.66-1.2c0,0-17.35,6.5-16.82,11.45,0,0-.74,1.47,6.78,1.15s19.19-.65,19.51-.82S221.72,303,220.13,291.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M247.67,274.89s.21,14.32.1,14.53,1,2,1,2l4.52.81,4.13-1.9s-.37-13.32.07-15.42S247.67,274.89,247.67,274.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M257.46,290.33s-5.21,1.82-9.66-1.19c0,0-17.35,6.5-16.82,11.44,0,0-.74,1.47,6.78,1.16s19.19-.66,19.51-.83S259.05,301.53,257.46,290.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M264.18,47.25s-1.1-2-2.18-1.35c-2.74,1.77-.41,4.57,1.25,5.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M264.26,40.11h0c0-.2,0-.41,0-.61a15.76,15.76,0,1,1,29.44,9.13c-1.79,3.53-3.36,6.55-4.95,9a22.56,22.56,0,0,0-3.42,13.87l.3,3.83c-10.11,4.25-14.08-.92-14.08-.92l.46-6.94a1.75,1.75,0,0,0-1.49-1.84h0C258.67,63.8,263.77,45.49,264.26,40.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M279.67,49.81a1.47,1.47,0,1,1,1.33,1.6A1.47,1.47,0,0,1,279.67,49.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M266.93,46a1.47,1.47,0,1,1,1.33,1.59A1.47,1.47,0,0,1,266.93,46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M285.11,48a.9.9,0,0,0,.45-.08.86.86,0,0,0,.4-1.15,4.6,4.6,0,0,0-6.12-2,.85.85,0,0,0-.48,1.11.86.86,0,0,0,1.11.49c2.81-1.1,3.9,1.08,3.94,1.18A.88.88,0,0,0,285.11,48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M271.63,44.48a.9.9,0,0,0,.45-.08.87.87,0,0,0,.4-1.15,4.6,4.6,0,0,0-6.12-2,.86.86,0,0,0-.49,1.11.87.87,0,0,0,1.12.49c2.8-1.1,3.89,1.08,3.94,1.18A.88.88,0,0,0,271.63,44.48Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "297 43.57 291.77 53.79 288.97 52.96 288.51 39.12 297 43.57"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M288.56,52.59a2.32,2.32,0,0,1,1.32-1c1.13-.34,3.08-.64,4.27.79,1.76,2.11-2.59,6.86-6.19,4C288,56.35,287,55.16,288.56,52.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M267.34,34.24s-2.4,1.38-3.82,10.85c0,0,.2-10.68,1.48-11.74S267.34,34.24,267.34,34.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M312.67,158.2l-51.43-14.91L242.4,157.7l1,17.65h-.07l-21.09,17.31a23.37,23.37,0,0,0-8.45,16L207.24,282h18l19.28-73v73h16.17l11.82-67L299.35,197A31,31,0,0,0,313,170.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M286.52,73.48h-15.7l-6.09,26.31v50.49s14.42,7,33.39-2.15l-5.53-59.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M286.52,73.48s23.69,10,28.34,16.47c4.3,6,3.7.29,16.08,33.7a13.82,13.82,0,0,1-1.72,12.85,9.29,9.29,0,0,1-4.35,3.26l-12.2,4.55,1.3,31-23.64,2.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M270.82,73.48S247.13,83.5,242.48,90s.89,85.39.89,85.39L267,177.67Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-12",
  points: "281.43 76.43 278.67 81.13 284.42 147.59 275.55 161.91 268.96 147.23 275.34 80.73 273.33 76.03 278.74 74.01 281.43 76.43"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "286.52 73.48 285.34 70.89 277.96 73.48 271.85 70.67 270.82 73.48 272.12 78.31 277.69 74.69 283.13 78.64 286.52 73.48"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M291.64,24.66c-.45-.46-1.28-.83-1.66-.31a1.13,1.13,0,0,0-.14.75,7.17,7.17,0,0,0,.53,2.19c-2.64-3.1-7.06-4.06-11.14-4s-8.12.95-12.2.75c-1.61-.08-3.55-.2-4.49,1.11a2.78,2.78,0,0,0,.15,3.17A4.88,4.88,0,0,0,265.52,30a2.2,2.2,0,0,0-2.76,3.12c.69,1.21,2.3,1.48,3.69,1.6a125.73,125.73,0,0,0,13.31.37l-1.94,1.57a1.64,1.64,0,0,0-.55.62,1.27,1.27,0,0,0,.19,1.11,3.28,3.28,0,0,0,2.6,1.32,13.16,13.16,0,0,0,3-.32,23,23,0,0,1,4.39-.3,2.06,2.06,0,0,1,.89.15,2.82,2.82,0,0,1,.88.84c1.56,1.88,4,2.68,6.38,3.39.73.22,1.69.36,2.09-.28a1.66,1.66,0,0,0,.19-.85,19.76,19.76,0,0,0-2.45-10.15,1.1,1.1,0,0,0,2,.07c.62-1.17-.85-2.14-1.68-2.62s-1.47-.53-2-1.27C292.82,27.25,292.73,25.78,291.64,24.66Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-13",
  points: "295.76 77.71 291.11 96.88 295.76 98.83 288.9 138.58 286.52 73.48 295.76 77.71"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-13",
  points: "261.58 77.71 266.23 96.88 261.58 98.83 268.43 138.58 270.82 73.48 261.58 77.71"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M244.57,209.25h0a.28.28,0,0,1-.28-.28c0-.1.06-9.88,5.86-17.47,3.68-4.82,21.33-15.65,22.08-16.11a.29.29,0,0,1,.3.49c-.18.11-18.31,11.24-21.92,16-5.68,7.43-5.75,17-5.75,17.12A.29.29,0,0,1,244.57,209.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M274.27,60.8a.35.35,0,0,1-.25-.1c-3.77-3.86-6.43-2.35-6.46-2.34a.32.32,0,0,1-.46-.12.33.33,0,0,1,.11-.46c.13-.08,3.15-1.8,7.3,2.45a.33.33,0,0,1-.24.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M258.71,141.24h4.58v-7.92H279v7.92h4.57v-8.38a3.85,3.85,0,0,0-3.73-4H262.45a3.86,3.86,0,0,0-3.74,4Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 236.07,
  y: 139.26,
  width: 67.71,
  height: 42.98,
  rx: 3.87,
  transform: "translate(539.85 321.51) rotate(180)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M268,162.57l.11,0,35.6-10.86a.36.36,0,0,0,.25-.46.39.39,0,0,0-.48-.24L268,161.81l-31.55-10.9a.39.39,0,0,0-.49.22.36.36,0,0,0,.23.47l31.68,11Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 265.92,
  y: 158.47,
  width: 4.05,
  height: 7.09,
  transform: "translate(535.88 324.04) rotate(180)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M290.49,137s-6.68-2.39-9.28-2.72-4.88-2.58-5.57-1.22S279.3,137,279.3,137s-5,1.81-6.65,2.13-4.39,1.65-4.25,2.86,7.86-.89,7.86-.89-6.32,2.4-6.43,3.55,8.39-.74,8.39-.74-6.87,2.24-7.25,2.88.42,1.17,3,1a25.09,25.09,0,0,0,5.25-1.08,55.88,55.88,0,0,0-5.19,2.36c-.49.43-.84,1.38,3,.67S289,146.05,292.48,143Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M231.32,157.08a4.15,4.15,0,0,1,1.18-4,4,4,0,0,1,1.53-.89c2.5-.8,4.33-3.43,5.25-2.22s-2.89,4.52-2.89,4.52,5.27.87,6.93.89,4.62.81,4.7,2-7.89.55-7.89.55,6.66,1.22,7,2.32-8.38.81-8.38.81,7.16.95,7.66,1.51-.21,1.22-2.83,1.5a25.25,25.25,0,0,1-5.35-.1s5,1,5.53,1.37,1.07,1.2-2.85,1.2a9.33,9.33,0,0,1-4.21-.62,8.25,8.25,0,0,1-4.61-5.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M293.93,148.19a.14.14,0,0,1-.13-.1L290,135.65a.15.15,0,0,1,.07-.17l20.91-12-5.83-13.92a.15.15,0,0,1,.27-.12l5.88,14a.15.15,0,0,1-.06.18l-20.93,12L294,147.88l18.62-3.71a.15.15,0,0,1,.17.12.14.14,0,0,1-.12.16L294,148.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M304.6,145.75v-5.66a1.67,1.67,0,0,0-1.67-1.67H291l2.92,9.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M312.65,144.17l-8.87,1.77v.29l8.92-1.78a.14.14,0,0,0,.12-.16A.15.15,0,0,0,312.65,144.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M290.27,135.67l20.93-12a.15.15,0,0,0,.06-.18l-5.88-14a.15.15,0,0,0-.27.12l5.83,13.92-20.91,12a.15.15,0,0,0-.07.17l1.12,3.61h.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M294,147.88l-2.65-8.62h-.3l2.72,8.83a.14.14,0,0,0,.13.1h0l9.82-2v-.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M279.87,34.92,263,13l9.46,25.31S280.41,39.44,279.87,34.92Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-14",
  points: "265.06 18.61 265.44 19.64 267.17 18.46 266.49 17.58 265.06 18.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-14",
  points: "269.06 20.92 266.58 22.7 266.96 23.72 269.75 21.82 269.06 20.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-14",
  points: "267.9 26.23 268.27 27.21 272.29 25.11 271.58 24.18 267.9 26.23"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-14",
  points: "269.43 30.3 269.79 31.28 274.96 28.57 274.23 27.63 269.43 30.3"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-14",
  points: "276.73 30.88 270.86 34.15 271.23 35.12 277.48 31.84 276.73 30.88"
})));

var SvgLostNoQuarter = function SvgLostNoQuarter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 550 320.27",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLostNoQuarter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lost_no_quarter.c66542cf.svg";
export { ForwardRef as ReactComponent };